<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'CtaProgrammeSurMesurePrendreRdv'
});
</script>
<template>
  <ka-container
    code="cta-programme-sur-mesure-prendre-rdv"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text
      code="text"
      :value="componentInstance.$title.value" />
    <ka-text
      code="text-1"
      :value="componentInstance.$text.value" />
    <ka-button
      code="button"
      :options="{
        ripple: true,
        href: componentInstance.$ctaLink.value,
        ariaLabel: `button`,
        click: componentInstance.buttonClick
      }"
      :value="componentInstance.$cta.value" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { ctaProgrammeSurMesurePrendreRdvComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c14')
const component = ctaProgrammeSurMesurePrendreRdvComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  text?: Nullable<string>
  cta?: Nullable<string>
  ctaLink?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: 'Ce programme n’est pas tout à fait ce dont vous avez besoin ?',
  text: 'Ça tombe bien ! Ce n’est qu’un exemple. Vous pouvez nous contacter pour nous décrire vos objectifs. Notre équipe se chargera de vous trouver les financements et les profils d\'experts qui matchent avec votre besoin. ',
  cta: 'Prendre rendez-vous',
  ctaLink: '/experts',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title',
  'update:text',
  'update:cta',
  'update:ctaLink'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    title: true,
    text: true,
    cta: true,
    ctaLink: true
  }
})
</script>
